//noScroll
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const interviewModalsTrigger = document.querySelectorAll(".js-interview-modalTrigger")
    const interviewModals = document.querySelectorAll(".js-interview-modal")
    const interviewModalsClose = document.querySelectorAll(".js-interview__modal-close")
    const body = document.querySelector("body")



    interviewModalsTrigger.forEach((modalTrigger, index) => {

      modalTrigger.addEventListener("click", () =>{
        if(index === 0){
          interviewModals[0].classList.add("is-active")
        }else if(index === 1){
          interviewModals[1].classList.add("is-active")
        }
        body.classList.add("is-fixed")
      })

      interviewModalsClose.forEach((closeBtn, index) => {
        closeBtn.addEventListener("click", () => {
          if(index === 0){
            interviewModals[0].classList.remove("is-active")
          }else if(index === 1){
            interviewModals[1].classList.remove("is-active")
          }
          body.classList.remove("is-fixed")
        })
      })



    })

    // interviewModalsClose.forEach((closeBtn, index) => {
    //   closeBtn.addEventListener("click", () =>{
    //     console.log("click");

    //     console.log(interviewModalsTrigger[0]);

    //     if(index === 0){
    //       interviewModalsTrigger[0].classList.remove("is-active")
    //     }else if(index === 1){
    //       interviewModalsTrigger[1].classList.remove("is-active")
    //     }
    //   })
    // })


  }
}
